/**
 * Suggested next prompts, offered after the agent finishes an answer.
 *
 * Selecting one submits an ordinary turn with its text, so a follow-up is a
 * shortcut for typing rather than a separate mechanism. The list disappears once
 * used, because a suggestion that has already been taken is no longer a
 * suggestion.
 */
import { ArrowRight, MessageSquare } from "lucide-react";
import type { FollowUpSuggestion } from "../../services/agui";

interface Props {
  suggestions: FollowUpSuggestion[];
  busy?: boolean;
  onSelect: (suggestion: FollowUpSuggestion) => void;
}

export default function FollowUps({ suggestions, busy = false, onSelect }: Props) {
  if (!suggestions.length) return null;

  return (
    <section className="followups" aria-label="Suggested follow-ups">
      <h4>Suggested follow-ups</h4>
      <ul>
        {suggestions.map((suggestion) => (
          <li key={suggestion.id}>
            <button
              type="button"
              disabled={busy}
              onClick={() => onSelect(suggestion)}
            >
              <MessageSquare size={14} aria-hidden="true" />
              <span>{suggestion.prompt}</span>
              <ArrowRight size={14} aria-hidden="true" className="followup-go" />
            </button>
          </li>
        ))}
      </ul>
    </section>
  );
}
